<template>
  <v-container
    fluid
    class="fill-height bg"
  >
    <v-row
      justify="center"
      align="center"
      class="fill-height ma-0 v-row__relative"
    >
      <v-btn
        fab
        absolute
        to="/app/processing-list"
        class="back-btn"
      >
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-card
        elevation="10"
      >
        <v-card-title>{{productName}}</v-card-title>
        <v-card-text>
          <v-container
            fluid
            class="fill-height"
          >
            <v-row
              class="fill-height ma-0"
            >
              <v-flex
                v-if="isLoading"
              >
                <v-progress-circular
                  indeterminate
                  color="info"
                  class="mr-2"
                >
                </v-progress-circular>
                <div class="subtitle-1">Carregando...</div>
              </v-flex>
              <v-flex
                v-else-if="isSuccess"
              >
                <v-alert
                  type="success"
                >
                  Redirecionando para o pagamento, aguarde um momento.
                </v-alert>
              </v-flex>
              <v-flex
                v-else
              >
                <v-alert
                  type="error"
                >
                  Ocorreu algum erro ao verificar os dados do produto, por favor tente novamente mais tarde.
                </v-alert>
              </v-flex>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
  import {describePhysicalProduct} from "../../api/api-billing"
  import {mapActions} from "vuex"
  import {SET_PAYMENT_DATA} from "../../store/modules/payment"
  import {PRODUCT_TYPE} from "../../helpers/payment/constants"
  import {keysToCamel} from "../../helpers/utils"

  export default {
    name: "ProductsPayment",
    data: () => ({
      isLoading: true,
      isSuccess: false,
    }),
    methods: {
      onCreated() {
        this.isLoading = true
        const authToken = this.$apiAuth.getAuthToken()
        const {product} = this.$route.params
        describePhysicalProduct(authToken, product)
          .then((res) => {
            this.isSuccess = true
            const {nmPhysicalProduct, nmPhysicalProductDescription, abPhysicalProduct} = keysToCamel(res.data.data)
            this.setPaymentData({
              productType: PRODUCT_TYPE.PHYSICAL_PRODUCT,
              productData: {
                name: nmPhysicalProduct,
                description: nmPhysicalProductDescription,
                abPhysicalProduct: abPhysicalProduct,
              },
            })
            setTimeout(() => {
              this.$router.push("/app/payment")
            }, 3000)
          })
          .finally(() => {
            this.isLoading = false
          })
      },
      ...mapActions({
        setPaymentData: SET_PAYMENT_DATA,
      }),
    },
    computed: {
      productName() {
        const {name} = this.$route.params
        if (name) return name.replace(/_/g, " ")
        return "Produto Físico"
      },
    },
    created() {
      this.onCreated()
    },
  }
</script>

<style scoped lang="scss">
  .bg {
    background-image: url("../../assets/general/bg.jpg");
    background-size: cover;
  }

  .v-row__relative {
    position: relative;
  }

  .back-btn {
    top: 0;
    left: 0;
  }
</style>
